import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
import providers from './includes/providers';
import players from './includes/players';
import parseUrl from './includes/parse-url';

const psGallery = downstageMedia.map((media, index) => {
    document.getElementById('media-' + media.id).onclick = (e) => {
        e.preventDefault();
        downstageGallery.show(index);
    };

    return providers.init(media).media;
});

const downstageGallery = {
    init() {
        const hash = parseUrl();

        if (hash.pid && hash.gid) {
            this.show(hash.pid - 1);
        }
    },
    show(mediaIndex = 0) {
        const ps = new PhotoSwipe(
            document.getElementById('gallery-popup'),
            PhotoSwipeUI_Default,
            psGallery,
            {
                index: mediaIndex,
                closeOnScroll: false,
                tapToClose: false,
                bgOpacity: 0.9,
            },
        );

        ps.listen('beforeChange', () => {
            players.pauseCurrent();
            players.init(ps.currItem);
        });

        ps.listen('gettingData', (index, item) => {
            item.html =
                '<div class="media-embed-wrapper">' +
                '<div class="media-embed-ratio">' +
                item.embed.replace('<iframe', `<iframe id="${item.embedId}"`) +
                '</div>' +
                '</div>';
        });

        ps.listen('close', () => {
            players.pauseCurrent();
            players.destroy();
        });

        ps.init();
    },
};

const dsProvidersReady = () => {
    const notReady = psGallery
        .map((media) => media.provider().ready())
        .filter((ready) => !ready);

    if (notReady.length > 0) {
        return setTimeout(dsProvidersReady, 50);
    }

    downstageGallery.init();
};

dsProvidersReady();
